//The time is displayed in minutes
const ONE_HOUR_MINUTES = 60

export default Object.freeze({
    en: [
        {
            label: '5 days',
            value: 120 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 days',
            value: 96 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 days',
            value: 72 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 days',
            value: 48 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 day',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 hours',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 hours',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 hours',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1.5 hours',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '45 minutes',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
        {
            label: '30 minutes',
            value: ONE_HOUR_MINUTES / 2,
        },
    ],
    sr: [
        {
            label: '5 dana',
            value: 120 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 dana',
            value: 96 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 dana',
            value: 72 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 dana',
            value: 48 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 dan',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 sata',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1.5 sat',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '45 minuta',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
        {
            label: '30 minuta',
            value: ONE_HOUR_MINUTES / 2,
        },
    ],
    ru: [
        {
            label: '5 дней',
            value: 120 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 дня',
            value: 96 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 дня',
            value: 72 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 дня',
            value: 48 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 день',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 часы',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 часы',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 часы',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1.5 часы',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '45 минуты',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
    ],
    bih: [
        {
            label: '5 dana',
            value: 120 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 dana',
            value: 96 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 dana',
            value: 72 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 dana',
            value: 48 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 dan',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 sata',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1.5 sat',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '45 minuta',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
    ],
})
